/* eslint-disable */

export default buffer => btoa(String.fromCharCode(...new Uint8Array(buffer)));
